module.exports = __webpack_public_path__ + "static/media/image_23.4b3b4355.png";